import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import { useReactToPrint } from 'react-to-print';

// Reactstrap components
import { Button, Col, Modal, ModalBody, ModalHeader, Row, Table } from "reactstrap";

// componentes
import ModalJustificativa from "components/ModalJustificativa/ModalJustificativa";
import ModalCancelamentoRequerimento from "components/ModalCancelamentoRequerimento/ModalCancelamentoRequerimento";

// style
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// helpers
import { formateDate, formateDateandTime, transformValueFloattoFormated } from "../../../helpers/formats";

// services
import { api_GET, api_POST } from "../../../services/api_service.js";
import { showMessage, showQuestion } from "../../../services/message.js";
import { CancelarRequerimentoByRequerimento } from "../../../services/requerimento_service.js";

// views
import FichaRequerimento from "./FichaRequerimento.jsx";

//Context
import { useAuth } from "../../../context/auth";

export default function FichaTransportador({ history, item, showAcoesGestor }) {
    const { session, setLoading, signOut, setupSistema } = useAuth();

    const [protocolo, set_protocolo] = React.useState(null);

    const [list_acoes, set_list_acoes] = React.useState(null);

    const [requerimento, set_requerimento] = React.useState(null);

    const [historicoDividaAtiva, set_historicoDividaAtiva] = React.useState([]);

    const [infracoesDividaAtiva, set_infracoesDividaAtiva] = React.useState([]);
    const [modalDividaAtiva, set_modalDividaAtiva] = useState(false);

    const toggleModalDividaAtiva = () => set_modalDividaAtiva(!modalDividaAtiva);

    const [modal, setModal] = useState(false);

    const toggleModal = () => setModal(!modal);

    const [modalCancelamento, setModalCancelamento] = useState(false);
    const [itemCancelamento, setItemCancelamento] = useState(null);

    const loadOptionsAcoes = () => {
        api_GET('SetupSolicitacao/GetListByProtocolo/' + item.numeroProtocolo)
            .then(result => set_list_acoes(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const handleOpenRequerimento = (rowData) => {
        if ((rowData.status == "Em Andamento" || rowData.status == "Divergente") && showAcoesGestor == false) {
            switch (rowData.setupSolicitacaoAcao.acao) {
                case "Novo Cadastro": {
                    window.location = '/auth/TransportadorRequerimento?protocolo=' + protocolo.numeroProtocolo;
                    break;
                }
                case "Inclusão":
                    history.push({
                        pathname: '/auth/TransportadorRequerimentoInclusaoVeiculo',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Exclusão":
                    history.push({
                        pathname: '/auth/TransportadorRequerimentoExclusaoVeiculo',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Renovação":
                    history.push({
                        pathname: '/auth/TransportadorRequerimentoRenovacao',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Renovação de Veículo":
                    history.push({
                        pathname: '/auth/TransportadorRequerimentoRenovacaoVeiculo',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Cancelamento":
                    history.push({
                        pathname: '/auth/RequerimentoCancelamento',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Alteração":
                    history.push({
                        pathname: '/auth/TransportadorRequerimentoAlteracao',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Alteração de Identificação":
                    history.push({
                        pathname: '/auth/TransportadorRequerimentoAlteracaoIdentificacao',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Alteração de Equipamentos":
                    history.push({
                        pathname: '/auth/TransportadorRequerimentoAlteracaoEquipamentos',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Exclusão de Equipamentos":
                    history.push({
                        pathname: '/auth/TransportadorRequerimentoExclusaoEquipamentos',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Taxa FisLurb":
                    history.push({
                        pathname: '/auth/RequerimentoTaxaFislurb',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
            }
        }
        else {
            setLoading(true);
            api_GET('requerimento/' + rowData.requerimento_Id)
                .then(result => set_requerimento(result.data))
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
    }

    const handleAtualizarContato = () => {
        history.push({
            pathname: '/auth/AtualizarContato',
            state: { protocolo: protocolo }
        })
    }

    const handleRequerimentoInclusaoVeiculo = (setupSolicitacaoAcao) => {
        showQuestion('Atenção', 'Deseja criar um requerimento de inclusão de veículo?', 'question', function (result) {
            if (result) {
                history.push({
                    pathname: '/auth/TransportadorRequerimentoInclusaoVeiculo',
                    state: { protocolo: protocolo, setupSolicitacaoAcao: setupSolicitacaoAcao }
                });
            }
        })
    }

    const handleRequerimentoExclusaoVeiculo = (setupSolicitacaoAcao) => {
        showQuestion('Atenção', 'Deseja criar um requerimento de exclusão de veículo?', 'question', function (result) {
            if (result) {
                history.push({
                    pathname: '/auth/TransportadorRequerimentoExclusaoVeiculo',
                    state: { protocolo: protocolo, setupSolicitacaoAcao: setupSolicitacaoAcao }
                })
            }
        })
    }

    const handleRequerimentoRenovarCadastro = (setupSolicitacaoAcao) => {
        if (protocolo.requerimento.filter(f => (f.setupSolicitacaoAcao.setupSolicitacaoAcao_Id == setupSolicitacaoAcao.setupSolicitacaoAcao_Id) &&
            !(f.status == "Cancelado" || f.status == "Finalizado")).length > 0) {
            showMessage("Aviso", "Você possui um Requerimento de RENOVAÇÃO em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!", 'error', null);
            return;
        }

        showQuestion('Atenção', 'Deseja criar um requerimento de renovação de cadastro?', 'question', function (result) {
            if (result) {
                history.push({
                    pathname: '/auth/TransportadorRequerimentoRenovacao',
                    state: { protocolo: protocolo, setupSolicitacaoAcao: setupSolicitacaoAcao }
                })
            }
        })
    }

    const handleRequerimentoRenovarVeiculo = (setupSolicitacaoAcao) => {
        showQuestion('Atenção', 'Deseja criar um requerimento de renovação de veículo?', 'question', function (result) {
            if (result) {
                history.push({
                    pathname: '/auth/TransportadorRequerimentoRenovacaoVeiculo',
                    state: { protocolo: protocolo, setupSolicitacaoAcao: setupSolicitacaoAcao }
                })
            }
        })
    }

    const handleRequerimentoCancelamento = (setupSolicitacaoAcao) => {
        if (protocolo.requerimento.filter(f => (f.setupSolicitacaoAcao.setupSolicitacaoAcao_Id == setupSolicitacaoAcao.setupSolicitacaoAcao_Id) &&
            !(f.status == "Cancelado" || f.status == "Finalizado")).length > 0) {
            showMessage("Aviso", "Você possui um Requerimento de CANCELAMENTO em andamento. Conclua o requerimento ou efetue o cancelamento antes de criar um novo!", 'error', null);
            return;
        }

        showQuestion('Atenção', 'Deseja criar um requerimento de cancelamento de cadastro?', 'question', function (result) {
            if (result) {
                history.push({
                    pathname: '/auth/RequerimentoCancelamento',
                    state: { protocolo: protocolo, setupSolicitacaoAcao: setupSolicitacaoAcao }
                })
            }
        })
    }

    const handleRequerimentoAlterarVeiculo = (setupSolicitacaoAcao) => {
        showQuestion('Atenção', 'Deseja criar um requerimento de alteração de veículo?', 'question', function (result) {
            if (result) {
                history.push({
                    pathname: '/auth/TransportadorRequerimentoAlteracao',
                    state: { protocolo: protocolo, setupSolicitacaoAcao: setupSolicitacaoAcao }
                })
            }
        })
    }

    const handleRequerimentoAlterarCadastro = (setupSolicitacaoAcao) => {
        if (protocolo.requerimento.filter(f => (f.setupSolicitacaoAcao.setupSolicitacaoAcao_Id == setupSolicitacaoAcao.setupSolicitacaoAcao_Id) &&
            !(f.status == "Cancelado" || f.status == "Finalizado")).length > 0) {
            showMessage("Aviso", "Você possui um Requerimento de ALTERAÇÃO em andamento. Conclua o requerimento ou efetue o cancelamento antes de criar um novo!", 'error', null);
            return;
        }

        showQuestion('Atenção', 'Deseja criar um requerimento de alteração de ficha de identificação?', 'question', function (result) {
            if (result) {
                history.push({
                    pathname: '/auth/TransportadorRequerimentoAlteracaoIdentificacao',
                    state: { protocolo: protocolo, setupSolicitacaoAcao: setupSolicitacaoAcao }
                })
            }
        })
    }

    const handleRequerimentoAlterarEquipamentos = (setupSolicitacaoAcao) => {
        if (protocolo.requerimento.filter(f => (f.setupSolicitacaoAcao.setupSolicitacaoAcao_Id == setupSolicitacaoAcao.setupSolicitacaoAcao_Id) &&
            !(f.status == "Cancelado" || f.status == "Finalizado")).length > 0) {
            showMessage("Aviso", "Você possui um Requerimento de ALTERAÇÃO em andamento. Conclua o requerimento ou efetue o cancelamento antes de criar um novo!", 'error', null);
            return;
        }

        showQuestion('Atenção', 'Deseja criar um requerimento de alteração de equipamentos?', 'question', function (result) {
            if (result) {
                history.push({
                    pathname: '/auth/TransportadorRequerimentoAlteracaoEquipamentos',
                    state: { protocolo: protocolo, setupSolicitacaoAcao: setupSolicitacaoAcao }
                })
            }
        })
    }

    const handleRequerimentoExclusaoEquipamentos = (setupSolicitacaoAcao) => {
        if (protocolo.requerimento.filter(f => (f.setupSolicitacaoAcao.setupSolicitacaoAcao_Id == setupSolicitacaoAcao.setupSolicitacaoAcao_Id) &&
            !(f.status == "Cancelado" || f.status == "Finalizado")).length > 0) {
            showMessage("Aviso", "Você possui um Requerimento de EXCLUSÃO em andamento. Conclua o requerimento ou efetue o cancelamento antes de criar um novo!", 'error', null);
            return;
        }

        showQuestion('Atenção', 'Deseja criar um requerimento de exclusão de equipamentos?', 'question', function (result) {
            if (result) {
                history.push({
                    pathname: '/auth/TransportadorRequerimentoExclusaoEquipamentos',
                    state: { protocolo: protocolo, setupSolicitacaoAcao: setupSolicitacaoAcao }
                })
            }
        })
    }

    const handleCancelarRequerimento = (item) => {
        setItemCancelamento(item);
        setModalCancelamento(true);
    };

    const handleRetornoCancelaRequerimento = (result) => {
        setLoading(false);
        showMessage("Aviso", "Requerimento cancelado com sucesso!", 'success', function () { window.location.reload() })
    }

    const handleRequerimentoNovoCadastro = () => {
        showQuestion('Atenção', 'Deseja criar requerimento de Novo Cadastro?', 'question', function (result) {
            if (result) {
                setLoading(true);

                api_POST(`requerimento/PostNovoRequerimento/${protocolo.protocolo_Id}`)
                    .then(result => {
                        showMessage("Aviso", "Requerimento criado com sucesso! Preencha seus dados na tela seguinte.", 'success', function () {
                            window.location.href = `/auth/TransportadorRequerimento?protocolo=${protocolo.numeroProtocolo}`;
                        });
                    })
                    .catch(err => showMessage("Aviso", err.message, 'error', null))
                    .finally(() => setLoading(false));
            }
        })
    }

    const handleRequerimentoTaxaFislurb = (setupSolicitacaoAcao) => {
        if (protocolo.requerimento.filter((f) => f.status == "Em Andamento" && f?.setupSolicitacaoAcao?.acao == "Taxa FisLurb").length > 0) {
            showMessage("Aviso", "Você já possui um Requerimento de Taxa FisLurb em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!", "error", null);
            return;
        }
        showQuestion("Atenção", "Deseja criar um requerimento de taxa fislurb?", "question",
            function (result) {
                if (result) {
                    history.push({
                        pathname: "/auth/RequerimentoTaxaFislurb",
                        state: {
                            protocolo: protocolo,
                            setupSolicitacaoAcao: setupSolicitacaoAcao,
                        },
                    });
                }
            }
        );
    }

    const handleReturnRequerimento = () => {
        set_requerimento(null);
    }

    // O histórico é trilha de auditoria da integração com o FiscSP: traz tentativa recusada e
    // mensagem técnica de erro, que interessam a quem opera o sistema e não ao transportador. Por
    // isso é exclusivo da área restrita - o endpoint recusa os demais. O badge de Dívida Ativa no
    // bloco Empresa continua visível para todos, inclusive na consulta pública.
    const loadHistoricoDividaAtiva = () => {
        if (session === null || !showAcoesGestor || !item || !item.protocolo_Id)
            return;

        api_GET(`DividaAtiva/GetHistorico/${item.protocolo_Id}`)
            .then(result => set_historicoDividaAtiva(result.data || []))
            .catch(() => set_historicoDividaAtiva([]));
    }

    useEffect(() => {
        set_protocolo(item);
        loadOptionsAcoes();
        if (item.status == "Cancelado") {
            showMessage("Aviso", "Seu cadastro encontra-se como Cancelado. Faça um novo Requerimento.", 'warning', null);
            return;
        }
    }, []);

    // A sessao e carregada de forma assincrona pelo contexto de autenticacao: sem depender dela
    // aqui, o historico nunca seria buscado para quem entra logado.
    // Os autos inscritos sao dado do proprio cadastro, e nao trilha da integracao: aparecem para
    // o gestor e para o transportador logado - a SP Regula pediu essa liberacao para o TR em
    // CE-3892, revertendo a restricao de CE-3889. Na consulta publica nao ha token, e o endpoint
    // exige usuario autenticado - ali o badge segue sem o link.
    const loadInfracoesDividaAtiva = () => {
        if (session === null || !item || !item.protocolo_Id)
            return;

        api_GET(`DividaAtiva/GetInfracoes/${item.protocolo_Id}`)
            .then(result => set_infracoesDividaAtiva(result.data || []))
            .catch(() => set_infracoesDividaAtiva([]));
    }

    useEffect(() => {
        loadHistoricoDividaAtiva();
        loadInfracoesDividaAtiva();
    }, [session]);

    const componentRef = React.useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        copyStyles: true
    });

    if (protocolo !== null && protocolo.requerimento.length > 0 && session === null) {
        const result = protocolo.requerimento
            .filter(x => x.fluxoCadastroEtapaAtual !== null && x.fluxoCadastroEtapaAtual?.descricao === "Aguardando Compensação"
                && x.setupSolicitacaoAcao.valorGuia > 0);
        if (result.length > 0) {
            showMessage("Aviso", `Os pagamentos dos boletos não devem ser efetuados via Bancos Digitais, pois o Sistema da Prefeitura não reconhece esses pagamentos, e assim o cadastro não será liberado!
              Por favor, efetuar os pagamentos pelos bancos: Banco do Brasil, Bancoob, Banco Inter, Banco Original, Bradesco, Caixa, Daycoval, Itaú, Correspondentes Bancários, Rendimento, Safra, Santander.`, "warning", null);
        }
    }

    const handleEmitirGuia = (requerimento_Id) => {
        let json_submit = {
            requerimento_Id: requerimento_Id,
            usuarioEmissao_Id: null,
        }

        setLoading(true);
        api_POST('AnaliseRequerimento/PostRequerimentoCobranca', json_submit).then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', window.location.reload()))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    return (
        <>
            <ModalCancelamentoRequerimento
                visibilidadeModal={modalCancelamento}
                setVisibilidadeModal={() => setModalCancelamento(false)}
                item={itemCancelamento}
                onCancelado={() => window.location.reload()}
            />
            {protocolo != null && protocolo.protocoloTransportador != null && protocolo.protocoloTransportador.length > 0 && requerimento == null &&
                <div>
                    <div className="row">
                        {(session == null || (session && session.tipoAcesso == "Protocolo")) &&
                            <div className="col-4 col-lg-4 text-start">
                                <Button color="warning" onClick={() => {
                                    signOut(false, () => {
                                        window.location.href = "/auth/meucadastro";
                                    });
                                }}><i class="fas fa-sign-out-alt"></i> Sair</Button>
                            </div>
                        }
                        <div className="col-8 col-lg-8 ml-auto text-right">
                            <Button color="danger" onClick={handlePrint}><i class="fas fa-print"></i> IMPRIMIR</Button>
                            {!showAcoesGestor &&
                                <Button color="info" onClick={() => handleAtualizarContato()} ><i class="fas fa-user"></i> Atualizar Contato</Button>
                            }
                        </div>
                    </div>
                    <div className={`card`} ref={componentRef}>
                        <div className="card-body">
                            {protocolo?.requerimento?.filter(x =>
                                x.fluxoCadastroEtapaAtual?.tipo == "Aguardando Aprovação de Guia" &&
                                x.status === "Pendente" &&
                                x.requerimentoTaxaFislurb != null &&
                                x.requerimentoTaxaFislurb.some(rtf =>
                                    rtf.requerimentoTaxaFislurbBoletos.some(b => !!b.guiaArrecadacao && !b.DataPagamento)
                                )
                            ).length > 0 &&
                                <p className="text-danger">Guia da Taxa Fislurb disponível para pagamento</p>
                            }
                            {protocolo.status != "Ativo" &&
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <h5 className="text-danger">* Cadastro {protocolo.status} no sistema</h5>
                                    </div>
                                </div>
                            }
                            <div className="row">
                                <div className="col-12 col-lg-12">
                                    <p>
                                        <b>Dívida Ativa:</b>{" "}
                                        <span className={`badge ${protocolo.dividaAtiva_Status === "Inscrito" ? "badge-danger" : "badge-success"}`}>
                                            {protocolo.dividaAtiva_Status || "Não Inscrito"}
                                        </span>
                                        {infracoesDividaAtiva.length > 0 &&
                                            <Button color="link" className="p-0 ml-2 align-baseline noPrint" onClick={() => toggleModalDividaAtiva()}>
                                                ver os autos
                                            </Button>
                                        }
                                        {protocolo.dividaAtiva_DataAtualizacao &&
                                            <small className="ml-2">atualizado em {formateDateandTime(protocolo.dividaAtiva_DataAtualizacao)}</small>
                                        }
                                    </p>
                                </div>
                            </div>
                            <div className="row text-center">
                                <div className="col-12 col-lg-12">
                                    <h2 className="titulo-solicitacao">{protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.descricao}</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-12">
                                    <h3 className="titulo-consulta">Empresa</h3>
                                    <div className="line-protocolo"></div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 col-lg-6 col-sm-12">
                                    <p><b>Fantasia:</b> {protocolo.protocoloTransportador[0].nome_Fantasia}</p>
                                </div>
                                <div className="col-6 col-lg-6 col-sm-12 text-mobile">
                                    <p><b>CNPJ/CPF:</b> {protocolo.cpf_Cnpj}</p>
                                </div>
                                <div className="col-6 col-lg-6 col-sm-12">
                                    <p><b>Razão Social:</b> {protocolo.protocoloTransportador[0].razaoSocial}</p>
                                </div>
                                <div className="col-2 col-lg-2 col-sm-12">
                                    <p><b>CCM:</b> {protocolo.protocoloTransportador[0].ccm}</p>
                                </div>
                                <div className="col-4 col-lg-4 col-sm-12">
                                    <p><b>Número Cadastro:</b> {protocolo.codigoCadastro}</p>
                                </div>
                                {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla != "RGG" &&
                                    <div className="col-4 col-lg-4 col-sm-12">
                                        <p><b>Ramo:</b> {protocolo.protocoloTransportador[0].ramoAtividade}</p>
                                    </div>}
                                <div className="col-4 col-lg-4 col-sm-12">
                                    <p><b>Tipo de Indústria / Coméricio:</b> {protocolo.protocoloTransportador[0].tipoIndustriaComercio}</p>
                                </div>
                                <div className="col-2 col-lg-2 col-sm-12">
                                    <p><b>CEP:</b> {protocolo.protocoloTransportador[0].cep}</p>
                                </div>
                                <div className="col-6 col-lg-6 col-sm-12">
                                    <p><b>Endereço:</b> {protocolo.protocoloTransportador[0].logradouro + ", " + protocolo.protocoloTransportador[0].numEndereco + ", " + protocolo.protocoloTransportador[0].complemento}</p>
                                </div>
                                <div className="col-6 col-lg-6 col-sm-12">
                                    <p><b>Bairro:</b> {protocolo.protocoloTransportador[0].bairro}</p>
                                </div>
                                <div className="col-6 col-lg-6 col-sm-12">
                                    <p><b>Cidade:</b> {protocolo.protocoloTransportador[0].cidade}</p>
                                </div>
                                <div className="col-6 col-lg-6 col-sm-12">
                                    <p><b>Fim da Vigência:</b> {protocolo.dataFimVigencia != null ? formateDate(protocolo.dataFimVigencia) : ""}</p>
                                </div>
                                {protocolo.codigoSistemaPrefeitura &&
                                    <div className="col-6 col-lg-6 col-sm-12">
                                        <p><b>Processo Credenciamento:</b> {protocolo.codigoSistemaPrefeitura}</p>
                                    </div>
                                }
                            </div>
                            {protocolo.protocoloTransportador[0].protocoloTransportadorClasseResiduo != null && protocolo.protocoloTransportador[0].protocoloTransportadorClasseResiduo.length > 0 &&
                                <div className="row">
                                    <div className="col-12 col-lg-12 col-sm-12">
                                        <p><b>Classe de Resíduos: </b>{protocolo.protocoloTransportador[0].protocoloTransportadorClasseResiduo.map((item, key) => (
                                            <div key={key}>{item.classeResiduo.descricao}</div>)
                                        )}</p>
                                    </div>
                                </div>
                            }
                            {protocolo != null && protocolo.status != "Pendente" && setupSistema && setupSistema.tipoCertificadoTransportador == "Geral" &&
                                <div className="row">
                                    <div className="col-12 col-lg-12 col-sm-12 text-center">
                                        <b>Certificado</b><br />
                                        <i style={{ cursor: "pointer" }} onClick={() => window.open("/empty/CertificadoTransportador?protocolo=" + protocolo.numeroProtocolo, "_blank")} className="fas fa-qrcode fa-2x"></i>
                                    </div>
                                </div>
                            }
                            <div className="row">
                                <div className="col-12 col-lg-12 col-sm-12">
                                    <h3 className="titulo-consulta">Responsável</h3>
                                    <div className="line-protocolo"></div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6 col-lg-6 col-sm-12">
                                    <h6 style={{ paddingTop: "5px" }}>{protocolo.protocoloTransportador[0].nomeResponsavel}</h6>
                                </div>
                                <div className="col-6 col-lg-6 col-sm-12 text-mobile">
                                    <h6 style={{ paddingTop: "5px" }}>{protocolo.email}</h6>
                                </div>
                                <div className="col-6 col-lg-6 col-sm-12">
                                    <p><b>Telefone:</b> {protocolo.protocoloTransportador[0].telefone}</p>
                                </div>
                                <div className="col-6 col-lg-6 col-sm-12 text-mobile">
                                    <p><b>Celular:</b> {protocolo.protocoloTransportador[0].celular}</p>
                                </div>
                                {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla == "RGG" &&
                                    <div className="col-12 col-lg-12 col-sm-12">
                                        <p><b>Responsável Técnico (CREA):</b> {protocolo.protocoloTransportador[0]?.nomeResponsavelTecnico ?? ""}</p>
                                    </div>}
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-12 col-sm-12">
                                    <h3 className="titulo-consulta">Veículos</h3>
                                    <div className="line-protocolo"></div>
                                </div>
                            </div>

                            {protocolo.protocoloTransportador[0].protocoloTransportadorVeiculo.map((item, key) => (
                                <div key={key}>
                                    <div className="row">
                                        <div className="col-2 col-lg-2">
                                            <b>Placa:</b> <p>{item.placa}</p>
                                        </div>
                                        <div className="col-2 col-lg-2">
                                            <b>Tipo:</b> <p>{item.tipo}</p>
                                        </div>
                                        {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla == "RGG" &&
                                            <div className="col-2 col-lg-4">
                                                <b>Modalidades:</b> {item.protocoloTransportadorVeiculoModalidades && item.protocoloTransportadorVeiculoModalidades.map((item, key) => (
                                                    <p key={key}>{item.modalidade}</p>))}
                                            </div>}
                                        <div className="col-4 col-lg-4">
                                            <b>Marca/Modelo:</b> <p>{item.marca}</p>
                                        </div>
                                        <div className="col-2 col-lg-2">
                                            <b>Ano Fabricação:</b> <p>{item.anoFabricacao}</p>
                                        </div>
                                        <div className="col-2 col-lg-2">
                                            <b>Ano Fab. Equip.:</b> <p>{item.anoFabricacaoEquipamento}</p>
                                        </div>
                                        <div className="col-2 col-lg-2">
                                            <b>Cor:</b> <p>{item.cor}</p>
                                        </div>
                                        <div className="col-2 col-lg-2">
                                            <b>Tara (kg):</b> <p>{item.tara}</p>
                                        </div>
                                        <div className="col-4 col-lg-4">
                                            <b>Capacidade (kg):</b> <p>{item.capacidadeCarga}</p>
                                        </div>
                                        <div className="col-2 col-lg-2">
                                            <b>Volume (m³):</b> <p>{transformValueFloattoFormated(item.volume)}</p>
                                        </div>
                                        <div className="col-4 col-lg-4">
                                            <b>Renavam:</b> <p>{item.numeroRenavam}</p>
                                        </div>
                                        <div className="col-4 col-lg-4">
                                            <b>Proprietário ou Locado:</b> <p>{item.proprietarioOuLocado}</p>
                                        </div>
                                        <div className="col-2 col-lg-2">
                                            <b>Status:</b> <p>{item.status}</p>
                                        </div>
                                        <div className="col-3 col-lg-3">
                                            <b>Data Vistoria:</b> <p>{item.dataVistoria != null ? formateDate(item.dataVistoria) : ""}</p>
                                        </div>
                                        <div className="col-3 col-lg-3">
                                            <b>Data Validade Vistoria:</b> <p>{item.dataValidadeVistoria != null ? formateDate(item.dataValidadeVistoria) : ""}</p>
                                        </div>
                                        {protocolo != null && protocolo.status != "Pendente" && setupSistema && setupSistema.tipoCertificadoTransportador == "Por Veículo" && item.status == "Ativo" &&
                                            <div className="col-2 col-lg-2">
                                                <b>Carteirinha</b><br />
                                                <i style={{ cursor: "pointer" }} onClick={() => window.open("/empty/CarteirinhaVeiculo?protocolo=" + protocolo.numeroProtocolo + "&veiculo=" + item.protocoloTransportadorVeiculo_Id, "_blank")} className="fas fa-qrcode fa-2x"></i>
                                            </div>
                                        }
                                        {item.arquivoRenavam != null &&
                                            <div className="col-3 col-lg-3">
                                                <a href={setupSistema?.caminhoVirtual + item.arquivoRenavam} target="_blank">Arquivo Renavam</a>
                                            </div>
                                        }
                                        {item.arquivoInspecaoInmetro != null &&
                                            <div className="col-3 col-lg-3">
                                                <a href={setupSistema?.caminhoVirtual + item.arquivoInspecaoInmetro} target="_blank">Arquivo Inspeção Inmetro</a>
                                            </div>
                                        }
                                        {item.arquivoComprovanteTara != null &&
                                            <div className="col-3 col-lg-3">
                                                <a href={setupSistema?.caminhoVirtual + item.arquivoComprovanteTara} target="_blank">Arquivo Comprovante Tara</a>
                                            </div>
                                        }
                                        {item.arquivoComodato != null &&
                                            <div className="col-3 col-lg-3">
                                                <a href={setupSistema?.caminhoVirtual + item.arquivoComodato} target="_blank">Arquivo Comodato</a>
                                            </div>
                                        }
                                    </div>
                                    <hr />
                                </div>
                            ))}

                            <div className="row">
                                <div className="col-12 col-lg-12">
                                    <h3 className="titulo-consulta">Locais de Guarda de Veículo</h3>
                                    <div className="line-protocolo"></div>
                                </div>
                            </div>

                            {protocolo.protocoloTransportador[0].protocoloTransportadorLocalGuarda.map((item, key) => (
                                <div key={key}>
                                    <div className="row">
                                        <div className="col-2 col-lg-2">
                                            <b>CEP:</b> <p>{item.cep}</p>
                                        </div>
                                        <div className="col-4 col-lg-4">
                                            <b>Endereço:</b> <p>{item.logradouro + ", " + item.numEndereco}</p>
                                        </div>
                                        <div className="col-4 col-lg-4">
                                            <b>Bairro:</b> <p>{item.bairro}</p>
                                        </div>
                                        <div className="col-2 col-lg-2">
                                            <b>Status:</b> <p>{item.status}</p>
                                        </div>
                                    </div>
                                    <hr />
                                </div>
                            ))}


                            <div className="row">
                                <div className="col-12 col-lg-12">
                                    <h3 className="titulo-consulta">Locais de Destinação</h3>
                                    <div className="line-protocolo"></div>
                                </div>
                            </div>

                            {protocolo.protocoloTransportador[0].protocoloTransportadorLocalDestino.map((item, key) => (
                                <div key={key}>
                                    <div className="row">
                                        <div className="col-2 col-lg-2">
                                            <b>CNPJ:</b> <p>{item.cnpj}</p>
                                        </div>
                                        <div className="col-4 col-lg-4">
                                            <b>Fantasia:</b> <p>{item.fantasia}</p>
                                        </div>
                                        <div className="col-4 col-lg-4">
                                            <b>Razão Social:</b> <p>{item.razaoSocial}</p>
                                        </div>
                                        <div className="col-2 col-lg-2">
                                            <b>Status:</b> <p>{item.status}</p>
                                        </div>
                                        <div className="col-2 col-lg-2">
                                            <b>CEP:</b> <p>{item.cep}</p>
                                        </div>
                                        <div className="col-4 col-lg-4">
                                            <b>Endereço:</b> <p>{item.logradouro + ", " + item.numEndereco}</p>
                                        </div>
                                        <div className="col-3 col-lg-3">
                                            <b>Bairro:</b> <p>{item.bairro}</p>
                                        </div>
                                        <div className="col-3 col-lg-3">
                                            <b>Cidade:</b> <p>{item.cidade}</p>
                                        </div>
                                    </div>
                                    <hr />
                                </div>
                            ))}

                            {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla != "RGG" &&
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <h3 className="titulo-consulta">Equipamentos</h3>
                                        <div className="line-protocolo"></div>
                                    </div>
                                </div>}

                            {protocolo.protocoloTransportador[0].protocoloTransportadorEquipamento.map((item, key) => (
                                <div key={key}>
                                    <div className="row">
                                        <div className="col-2 col-lg-2">
                                            <b>Número:</b> <p>{item.numeroEquipamento}</p>
                                        </div>
                                        <div className="col-2 col-lg-2">
                                            <b>Tipo:</b> <p>{item.tipo}</p>
                                        </div>
                                        <div className="col-3 col-lg-3">
                                            <b>Dimensão:</b> <p>{item.dimensao}</p>
                                        </div>
                                        <div className="col-3 col-lg-3">
                                            <b>Capacidade (m³):</b> <p>{item.capacidadeVolume}</p>
                                        </div>
                                        <div className="col-2 col-lg-2">
                                            <b>Status:</b> <p>{item.status}</p>
                                        </div>
                                    </div>
                                    <hr />
                                </div>
                            ))}

                            <div className="row">
                                <div className="col-12 col-lg-12">
                                    <h3 className="titulo-consulta">Documentos</h3>
                                    <div className="line-protocolo"></div>
                                </div>

                                <MaterialTable style={{ minHeight: "auto", width: "100%" }}
                                    title=""
                                    columns={[
                                        { title: 'Documento', field: 'documento.descricao' },
                                        { title: 'Arquivo', field: 'arquivo' }
                                    ]}
                                    data={protocolo.protocoloDocumentos}
                                    isLoading={false}
                                    actions={[
                                        {
                                            icon: 'insert_drive_file',
                                            tooltip: 'Visualizar Documento',
                                            onClick: (event, rowData) => window.open(setupSistema?.caminhoVirtual + rowData.arquivo, '_blank')
                                        }
                                    ]}
                                    localization={table_translate}
                                    options={table_style}
                                />
                            </div>
                            <div className="row mt-4">
                                <div className="col-12 col-lg-12">
                                    <h3 className="titulo-consulta">Requerimentos</h3>
                                    <div className="line-protocolo"></div>
                                </div>

                                <MaterialTable style={{ minHeight: "auto", width: "100%" }}
                                    title=""
                                    columns={[
                                        { title: 'Número', field: 'numeroRequerimento' },
                                        { title: 'Tipo', field: 'setupSolicitacaoAcao.acao' },
                                        { title: 'Etapa', field: 'fluxoCadastroEtapaAtual.tipo', render: (rowData) => rowData.fluxoCadastroEtapaAtual != null ? rowData.fluxoCadastroEtapaAtual.tipo : "" },
                                        { title: 'Status', field: 'status' },
                                        { title: 'Data Requerimento', field: 'dataCriacaoRequerimento', render: (rowData) => formateDate(rowData.dataCriacaoRequerimento) },
                                        { title: 'Atualizado Em', field: 'dataUltimaAcao', render: (rowData) => formateDateandTime(rowData.dataUltimaAcao) },
                                        { title: 'Data de Aceite', field: 'fluxoCadastroEtapaAtual.tipo', render: (rowData) => rowData.dataAceiteDeclaracao != null ? formateDateandTime(rowData.dataAceiteDeclaracao) : "" },
                                        { title: 'Data de Finalização', field: 'dataUltimaAcao', render: (rowData) => rowData.dataUltimaAcao != null && rowData.status === "Finalizado" ? formateDateandTime(rowData.dataUltimaAcao) : "" },
                                    ]}
                                    data={protocolo.requerimento.sort(function (a, b) { return new Date(b.dataCriacaoRequerimento) - new Date(a.dataCriacaoRequerimento); })}
                                    isLoading={false}
                                    actions={[
                                        {
                                            icon: 'insert_drive_file',
                                            tooltip: 'Visualizar Detalhes',
                                            onClick: (event, rowData) => handleOpenRequerimento(rowData)
                                        },
                                        (rowData) => {
                                            return (rowData.status == "Em Andamento" || rowData.status == "Divergente" || rowData.status == "Pendente") && {
                                                icon: 'cancel',
                                                tooltip: 'Cancelar Requerimento',
                                                onClick: (event, rowData) => handleCancelarRequerimento(rowData)
                                            }
                                        }
                                    ]}
                                    localization={table_translate}
                                    options={table_style}
                                />
                            </div>

                            <Row className="mt-4">
                                <Col lg="12">
                                    <h3 className="titulo-consulta">Histórico de Alteração de E-mail</h3>
                                    <div className="line-protocolo"></div>
                                </Col>


                                <MaterialTable
                                    style={{ minHeight: "auto", width: "100%" }}
                                    title=""
                                    columns={[
                                        { title: "Data/Hora", field: "dataHora", render: (rowData) => formateDateandTime(rowData.dataHora) },
                                        { title: "Usuário", field: "nomeUsuario" },
                                        { title: "E-mail Antigo", field: "emailAntigo" },
                                        { title: "E-mail Atual", field: "emailAtual" },
                                    ]}
                                    data={protocolo?.protocoloHistoricoContatos}
                                    isLoading={false}
                                    options={{
                                        filtering: false,
                                        exportButton: true,
                                        filtering: false,
                                        exportButton: true,
                                    }}
                                    localization={table_translate}
                                />


                            </Row>
                            {showAcoesGestor && historicoDividaAtiva.length > 0 &&
                                <Row className="mt-4">
                                    <Col lg="12">
                                        <h3 className="titulo-consulta">Histórico de Dívida Ativa</h3>
                                        <div className="line-protocolo"></div>
                                    </Col>

                                    <MaterialTable
                                        style={{ minHeight: "auto", width: "100%" }}
                                        title=""
                                        columns={[
                                            { title: "Data/Hora", field: "dataRecebimento", render: (rowData) => formateDateandTime(rowData.dataRecebimento) },
                                            { title: "Status Recebido", field: "status" },
                                            { title: "Resultado", field: "sucesso", render: (rowData) => rowData.sucesso ? "Sucesso" : "Falha" },
                                            { title: "Observação", field: "mensagem" },
                                        ]}
                                        data={historicoDividaAtiva}
                                        isLoading={false}
                                        options={{
                                            filtering: false,
                                            exportButton: true,
                                        }}
                                        localization={table_translate}
                                    />
                                </Row>
                            }
                            {modalDividaAtiva &&
                                <Modal isOpen={modalDividaAtiva} toggle={toggleModalDividaAtiva} size="lg">
                                    <ModalHeader toggle={toggleModalDividaAtiva}>Autos de infração inscritos em Dívida Ativa</ModalHeader>
                                    <ModalBody>
                                        <Table responsive striped>
                                            <thead>
                                                <tr>
                                                    <th>Auto de Infração</th>
                                                    <th>Data da Inscrição</th>
                                                    <th>Situação</th>
                                                    <th>Valor</th>
                                                    <th>Processo SEI</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {infracoesDividaAtiva.map(infracao =>
                                                    <tr key={infracao.dividaAtivaInfracao_Id}>
                                                        <td>{infracao.numeroInfracao}</td>
                                                        <td>{infracao.dataInscricao ? formateDate(infracao.dataInscricao) : "-"}</td>
                                                        <td>
                                                            {infracao.dataBaixa
                                                                ? <span className="badge badge-success">Baixado em {formateDate(infracao.dataBaixa)}</span>
                                                                : <span className="badge badge-danger">Inscrito</span>
                                                            }
                                                        </td>
                                                        <td>{infracao.valor ? transformValueFloattoFormated(infracao.valor) : "-"}</td>
                                                        <td>{infracao.numeroProcessoSEI || "-"}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </ModalBody>
                                </Modal>
                            }
                            {modal &&
                                <ModalJustificativa
                                    visibilidadeModal={modal}
                                    setVisibilidadeModal={toggleModal}
                                    item={item} />
                            }
                            <div className="text-center noPrint">
                                {showAcoesGestor && item?.protocoloJustificativas?.length > 0 &&
                                    <Button color="warning" onClick={() => toggleModal()}>
                                        <i className="fas fa-info mr-2"></i>
                                        Justificativas Protocolo
                                    </Button>
                                }
                                {showAcoesGestor == false && protocolo.status != "Cancelado" && list_acoes != null && list_acoes.map((prop, key) => {
                                    if (prop.acao == "Cancelamento") {
                                        return (<Button key={key} color="danger" onClick={() => handleRequerimentoCancelamento(prop)}>{prop.identificacao}</Button>);
                                    }
                                })}


                                {showAcoesGestor == false && (protocolo.status == "Ativo" || protocolo.status == "Pendente") && list_acoes != null && list_acoes.map((prop, key) => {
                                    if (prop.acao == "Alteração") {
                                        return (<Button key={key} color="warning" onClick={() => handleRequerimentoAlterarVeiculo(prop)}>{prop.identificacao}</Button>);
                                    }

                                    if (prop.acao == "Alteração de Identificação") {
                                        return (<Button key={key} color="warning" onClick={() => handleRequerimentoAlterarCadastro(prop)}>{prop.identificacao}</Button>);
                                    }

                                    if (prop.acao == "Alteração de Equipamentos") {
                                        return (<Button key={key} color="warning" onClick={() => handleRequerimentoAlterarEquipamentos(prop)}>{prop.identificacao}</Button>);
                                    }

                                    if (prop.acao == "Exclusão de Equipamentos") {
                                        return (<Button key={key} color="primary" onClick={() => handleRequerimentoExclusaoEquipamentos(prop)}>{prop.identificacao}</Button>);
                                    }

                                    if (prop.acao == "Inclusão") {
                                        return (<Button key={key} color="info" onClick={() => handleRequerimentoInclusaoVeiculo(prop)}>{prop.identificacao}</Button>);
                                    }

                                    if (prop.acao == "Exclusão") {
                                        return (<Button key={key} color="primary" onClick={() => handleRequerimentoExclusaoVeiculo(prop)}>{prop.identificacao}</Button>);
                                    }

                                    if (prop.acao == "Renovação") {
                                        return (<Button key={key} color="success" onClick={() => handleRequerimentoRenovarCadastro(prop)}>{prop.identificacao}</Button>);
                                    }
                                })}

                                {showAcoesGestor == false && (protocolo.status == "Vencido" || protocolo.status == "Inativo" || protocolo.status == "Irregular") && list_acoes != null && list_acoes.map((prop, key) => {
                                    if (prop.acao == "Renovação") {
                                        return (<Button key={key} color="success" onClick={() => handleRequerimentoRenovarCadastro(prop)}>{prop.identificacao}</Button>);
                                    }
                                })}

                                {showAcoesGestor == false && protocolo.status == "Cancelado" && list_acoes != null && list_acoes.map((prop, key) => {
                                    if (prop.acao == "Novo Cadastro") {
                                        return (<Button key={key} color="success" onClick={() => handleRequerimentoNovoCadastro(prop)}>{prop.identificacao}</Button>);
                                    }
                                })}

                                {showAcoesGestor == false && protocolo.status == "Irregular" && list_acoes != null && list_acoes.map((prop, key) => {
                                    if (prop.acao == "Inclusão") {
                                        return (<Button key={key} color="info" onClick={() => handleRequerimentoInclusaoVeiculo(prop)}>{prop.identificacao}</Button>);
                                    }
                                })}

                                {showAcoesGestor == false && list_acoes != null && list_acoes.map((prop, key) => {
                                    if (prop.acao == "Renovação de Veículo") {
                                        return (<Button key={key} color="warning" onClick={() => handleRequerimentoRenovarVeiculo(prop)}>{prop.identificacao}</Button>);
                                    }
                                })}

                                {showAcoesGestor == false &&
                                    protocolo?.requerimento?.filter(x =>
                                        x.status == "Pendente" &&
                                        x.fluxoCadastroEtapaAtual !== null &&
                                        x.fluxoCadastroEtapaAtual?.tipo?.toUpperCase() == "EMISSÃO DE GUIA").length > 0 &&
                                    setupSistema && setupSistema.metodologiaCobranca == "Integração PRODAM" &&
                                    <Button
                                        color="dark"
                                        onClick={() => handleEmitirGuia(protocolo?.requerimento?.filter(x => x.status == "Pendente" && x.fluxoCadastroEtapaAtual !== null && x.fluxoCadastroEtapaAtual?.tipo?.toUpperCase() == "EMISSÃO DE GUIA")[0].requerimento_Id)}
                                    >
                                        Emitir Guia
                                    </Button>
                                }

                                {showAcoesGestor == false &&
                                    list_acoes != null &&
                                    list_acoes.map((prop, key) => {
                                        if (prop.acao?.toLowerCase() === "taxa fislurb") {
                                            return (<Button key={key} color="warning" onClick={() => handleRequerimentoTaxaFislurb(prop)}> {prop.identificacao}</Button>);
                                        }
                                    })}
                            </div>
                        </div>
                    </div >
                </div >
            }
            {requerimento != null &&
                <FichaRequerimento
                    item={requerimento}
                    setLoading={setLoading}
                    handleReturn={handleReturnRequerimento}
                    showAcoesGestor={showAcoesGestor}
                />
            }
        </>
    )
}
